import { Stack } from '@mui/material';
import { FilterField } from './FilterField';

export function ExternalVehicleFilter({
  value = {},
  onChange,
  filterValues = {},
}) {
  const handleFilterChange = (field) => (event, update) => {
    onChange({
      ...value,
      [field]: update,
    });
  };

  return (
    <Stack spacing={1} sx={{ maxHeight: 238, overflow: 'scroll', pt: 0.75 }}>
      <FilterField
        label="Registration"
        value={value.registrationNumber}
        onChange={handleFilterChange('registrationNumber')}
        options={filterValues['properties.registrationNumber'] ?? []}
      />
      <FilterField
        label="Fleet #"
        value={value.fleetNumber}
        onChange={handleFilterChange('fleetNumber')}
        options={filterValues['properties.fleetNumber'] ?? []}
      />
      <FilterField
        label="Role"
        value={value.role}
        onChange={handleFilterChange('role')}
        options={filterValues['properties.role'] ?? []}
      />
    </Stack>
  );
}
